<template>
  <div class="dashboard-container">
    <h1>{{ $t('dashboard.title') }}</h1>
<!--    <p>欢迎使用管理系统</p>-->

    <el-row :gutter="20" class="panel-group">
      <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper">
            <i class="el-icon-user card-panel-icon"></i>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">{{ $t('dashboard.totalUsers') }}</div>
            <div class="card-panel-num">1,234</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper">
            <i class="el-icon-s-order card-panel-icon"></i>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">{{ $t('dashboard.totalOrders') }}</div>
            <div class="card-panel-num">5,678</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper">
            <i class="el-icon-s-data card-panel-icon"></i>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">{{ $t('dashboard.sales') }}</div>
            <div class="card-panel-num">¥89,012</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper">
            <i class="el-icon-message card-panel-icon"></i>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">{{ $t('dashboard.messages') }}</div>
            <div class="card-panel-num">12</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DashboardView'
}
</script>

<style scoped>
  .dashboard-container {
    margin-top: 20px;
    padding: 20px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .panel-group {
    margin-top: 20px;
  }

  .card-panel-col {
    margin-bottom: 20px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 20px;
    display: flex;
    align-items: center;
  }

  .card-panel-icon-wrapper {
    float: left;
    margin-right: 20px;
    padding: 16px;
    border-radius: 6px;
    background-color: #f0f9eb;
  }

  .card-panel-icon {
    float: left;
    font-size: 36px;
    color: #67C23A;
  }

  .card-panel-description {
    font-weight: bold;
  }

  .card-panel-text {
    line-height: 18px;
    color: #909399;
    font-size: 14px;
    margin-bottom: 12px;
  }

  .card-panel-num {
    font-size: 24px;
    color: #303133;
  }

  @media (max-width: 768px) {
    .card-panel {
      height: auto;
      padding: 15px;
    }

    .card-panel-icon-wrapper {
      padding: 12px;
      margin-right: 15px;
    }

    .card-panel-icon {
      font-size: 28px;
    }

    .card-panel-num {
      font-size: 20px;
    }
  }
</style>